// This module should be used to access the Date object, so it can be mocked in the unit tests
// mockRequire("libs/date", myFakeDate);
export default Date;
